import React from 'react';
import clsx from 'clsx';
import { useCustomComponent } from '@/hooks';

export interface FormGroupContainerProps {
  children: React.ReactNode;
  className?: string;
  animationDelayS?: number;
}

const ContainerComponent: React.FC<FormGroupContainerProps> = ({
  children,
  className,
  animationDelayS = 0,
}) => {
  return (
    <div
      className={clsx('peptalk-form-group', 'fade-in-up', className)}
      style={{ animationDelay: `${animationDelayS}s` }}
    >
      {children}
    </div>
  );
};

export const Container: React.FC<FormGroupContainerProps> = (
  props: FormGroupContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'FormGroupContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
